export const Routes = {
  EMPLOYEES_V2_WITH_PARAMS:
    "/v2/employees?states=active&states=not-active&states=pending-email-verification&states=blocked",
  EDIT_BENEFIT_BAG: (compensationPlan: string, deliveryId: string) =>
    `/v2/benefits/compensation-plan/${compensationPlan}/delivery/${deliveryId}/edit`,
};
